import React, { FC } from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import { useLocalSelector } from '@app/services/hooks/useRedux';

export const SandboxStatus: FC = () => {
  const isSandbox = useLocalSelector((state) => state.currentSession.data?.scope.is_sandbox);
  const { t } = useTranslation(NSKeys.spaceSettings);
  const { token } = theme.useToken();

  if (!isSandbox) {
    return null;
  }

  return (
    <Tooltip
      title={
        <Link to="/dashboard/account" style={{ display: 'block', color: 'inherit', textDecoration: 'none' }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('organization.sandboxTitle')}</div>
          <div>{t('organization.sandboxInReview')}</div>
        </Link>
      }
      placement="right"
    >
      <Link
        to="/dashboard/account"
        aria-label={t('organization.sandboxTitle')}
        style={{
          position: 'absolute',
          top: -5,
          right: -5,
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: token.colorWarningBg,
          color: token.colorWarning,
          boxShadow: `0 0 0 2px ${token.colorBgContainer}`,
          fontSize: 10,
          cursor: 'pointer',
          textDecoration: 'none',
        }}
      >
        <ExclamationCircleFilled />
      </Link>
    </Tooltip>
  );
};
